import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial?",
  answer: 'Every new account gets free credits to test the Google Maps scraper before committing to a paid plan. You can extract business data, emails, and phone numbers — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'What data can I extract from Google Maps?',
  answer: 'Our Google Maps scraper extracts business name, full address, phone number, website URL, star rating, total review count, business categories, operating hours, and coordinates. We then enrich this with verified email addresses and owner contacts from our proprietary database.'
}, {
  question: 'Is this a Google Maps email extractor?',
  answer: 'Yes! While Google Maps itself rarely displays email addresses, our platform acts as a powerful Google Maps email extractor by cross-referencing the scraped business websites and our proprietary database to find verified owner and company emails.'
}, {
  question: 'How does the Google Maps phone number scraper work?',
  answer: 'Our Google Maps phone number scraper extracts the public phone numbers listed on Google Business Profiles. We then verify these numbers to ensure they are active and format them cleanly for your CRM or dialer.'
}, {
  question: 'How fresh is the Google Maps data?',
  answer: 'We continuously crawl, verify, and update our database of millions of local businesses. Records are updated on a weekly basis, ensuring you always have accurate, up-to-date local business data.'
}, {
  question: 'Are there any rate limits or IP blocks?',
  answer: 'No. Unlike traditional scraping tools where you have to manage your own proxies and deal with captchas, Openmart handles all the infrastructure. You simply request the local business data you need, and we deliver it instantly.'
}, {
  question: 'Can I export Google Maps data as CSV?',
  answer: 'Absolutely. You can export your scraped Google Maps data as CSV, or sync directly to Salesforce, HubSpot, and other CRMs. The export includes all enriched fields — emails, phone numbers, ratings, reviews, and more.'
}, {
  question: 'Does Openmart work as a Google reviews scraper?',
  answer: 'Yes! Our google reviews scraper extracts star ratings, total review counts, and review sentiment data for every google local business listing. This makes it easy to filter leads by reputation, identify high-rated prospects, or analyze competitor review trends at scale.'
}, {
  question: 'Is this a Google Places API alternative?',
  answer: 'Openmart is the best Google Places API alternative for lead generation. Unlike the Google Places API, which has strict rate limits, per-request pricing, and limited contact data, our google map scraper delivers enriched business data — including emails and owner contacts — at a flat monthly price with no API complexity.'
}];
export function ScraperFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-2142">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2143">
        <div className="text-center mb-10" data-id="element-2144">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-2145">
            Frequently asked <span className="text-blue-600" data-id="element-2146">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-2147">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-2148">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-2149">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-2150">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-2151" />
                </button>

                <AnimatePresence data-id="element-2152">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-2153">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-2154" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}